import { useLayoutEffect } from 'react'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import Hero from './components/Hero'
import IntroSection from './components/IntroSection'
import ValueSection from './components/ValueSection'
import CTASection from './components/CTASection'
import HowItWorksSection from './components/HowItWorksSection'
import Footer from './components/Footer'

gsap.registerPlugin(ScrollTrigger)

export default function LandingPage() {
  useLayoutEffect(() => {
    // Clear any residual styles left by a previous route's pin/scroll-lock
    document.documentElement.style.overflow = ''
    document.documentElement.style.height = ''
    document.body.style.overflow = ''
    document.body.style.height = ''
    document.body.style.touchAction = ''

    window.scrollTo(0, 0)

    let raf2 = 0
    const raf1 = requestAnimationFrame(() => {
      raf2 = requestAnimationFrame(() => {
        ScrollTrigger.refresh()
      })
    })

    const onLoad = () => ScrollTrigger.refresh()
    window.addEventListener('load', onLoad)

    return () => {
      cancelAnimationFrame(raf1)
      if (raf2) cancelAnimationFrame(raf2)
      window.removeEventListener('load', onLoad)

      // Safety net: clear any body/html styles GSAP pin may have left behind
      document.documentElement.style.overflow = ''
      document.documentElement.style.height = ''
      document.body.style.overflow = ''
      document.body.style.height = ''
      document.body.style.touchAction = ''
    }
  }, [])

  return (
    <div className="min-h-screen overflow-x-hidden bg-oak-cream">
      <Hero />
      <IntroSection />
      <ValueSection />
      <CTASection />
      <div>
        <img
          src={require('../assets/camping-friends.png')}
          alt="Friends camping together"
          className="h-auto w-full rounded-section"
        />
      </div>
      <HowItWorksSection />
      <Footer />
    </div>
  )
}
